export const AUTH = {
  loginEmail: 'auth-login-email-input',
  loginPassword: 'auth-login-password-input',
  loginSubmit: 'auth-login-submit-button',
  registerEmail: 'auth-register-email-input',
  registerPassword: 'auth-register-password-input',
  registerName: 'auth-register-name-input',
  registerSubmit: 'auth-register-submit-button',
  logoutButton: 'auth-logout-button',
  demoLoginAdmin: 'auth-demo-login-admin-button',
  demoLoginCleaner: 'auth-demo-login-cleaner-button',
};

export const NAV = {
  sidebar: 'nav-sidebar',
  topbar: 'nav-topbar',
  logo: 'nav-logo',
  toDashboard: 'nav-dashboard-link',
  toCustomers: 'nav-customers-link',
  toProperties: 'nav-properties-link',
  toJobs: 'nav-jobs-link',
  toCalendar: 'nav-calendar-link',
  toPipeline: 'nav-pipeline-link',
  toEstimates: 'nav-estimates-link',
  toInvoices: 'nav-invoices-link',
  toPayments: 'nav-payments-link',
  toPricebook: 'nav-pricebook-link',
  toInventory: 'nav-inventory-link',
  toIssues: 'nav-issues-link',
  toInbox: 'nav-inbox-link',
  toReports: 'nav-reports-link',
  toSettings: 'nav-settings-link',
  mobileTabMyDay: 'nav-mobile-my-day',
  mobileTabJobs: 'nav-mobile-jobs',
  mobileTabInbox: 'nav-mobile-inbox',
  mobileTabInventory: 'nav-mobile-inventory',
  mobileTabProfile: 'nav-mobile-profile',
};

export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const CUSTOMERS = {
  createButton: 'customers-create-button',
  formName: 'customer-form-name-input',
  formEmail: 'customer-form-email-input',
  formPhone: 'customer-form-phone-input',
  formAddress: 'customer-form-address-input',
  formTags: 'customer-form-tags-input',
  formNotes: 'customer-form-notes-input',
  formSubmit: 'customer-form-submit-button',
  listRow: 'customer-list-row',
};

export const PROPERTIES = {
  createButton: 'properties-create-button',
  formNickname: 'property-form-nickname-input',
  formCustomer: 'property-form-customer-select',
  formAddress: 'property-form-address-input',
  formBedrooms: 'property-form-bedrooms-input',
  formBathrooms: 'property-form-bathrooms-input',
  formSqft: 'property-form-sqft-input',
  formIcal: 'property-form-ical-input',
  formBuffer: 'property-form-buffer-input',
  formDuration: 'property-form-duration-input',
  formSubmit: 'property-form-submit-button',
  syncButton: 'property-sync-ical-button',
  tabsChecklist: 'property-tabs-checklist',
  tabsInventory: 'property-tabs-inventory',
  tabsReservations: 'property-tabs-reservations',
};

export const JOBS = {
  createButton: 'jobs-create-button',
  formCustomer: 'job-form-customer-select',
  formProperty: 'job-form-property-select',
  formCleaner: 'job-form-cleaner-select',
  formSchedule: 'job-form-schedule-input',
  formSubmit: 'job-form-submit-button',
  filterAll: 'jobs-filter-all',
  filterScheduled: 'jobs-filter-scheduled',
  filterInProgress: 'jobs-filter-in-progress',
  filterFinished: 'jobs-filter-finished',
  viewList: 'jobs-view-list',
  viewCalendar: 'jobs-view-calendar',
  viewKanban: 'jobs-view-kanban',
  detailAdvance: 'job-advance-state-button',
  detailCancel: 'job-cancel-button',
  detailAssign: 'job-assign-cleaner-button',
  detailAutoPrice: 'job-autoprice-button',
  addLineItem: 'job-add-line-item-button',
  checklistInit: 'job-checklist-init-button',
  checklistItemComplete: 'checklist-item-complete-checkbox',
  checklistItemCapture: 'checklist-item-capture-photo-button',
  checklistItemUpload: 'checklist-item-photo-input',
  reportIssue: 'job-report-issue-button',
};

export const INVOICES = {
  createButton: 'invoices-create-button',
  remindButton: 'invoice-remind-button',
  addPayment: 'invoice-add-payment-button',
};

export const SETTINGS = {
  saveTemplate: 'notification-template-save-button',
  addPricingRule: 'pricing-rule-add-button',
  addKanbanStage: 'kanban-stage-add-button',
  inviteCleaner: 'users-invite-cleaner-button',
};

export const PORTAL = {
  loginEmail: 'portal-login-email-input',
  loginPassword: 'portal-login-password-input',
  loginSubmit: 'portal-login-submit-button',
  magicLinkRequest: 'portal-magic-link-request-button',
  navDashboard: 'portal-nav-dashboard',
  navInvoices: 'portal-nav-invoices',
  navSchedule: 'portal-nav-schedule',
  navMessages: 'portal-nav-messages',
  navServiceRequests: 'portal-nav-service-requests',
  navReports: 'portal-nav-reports',
  navProperties: 'portal-nav-properties',
  navLogout: 'portal-nav-logout',
  invoicePay: 'portal-invoice-pay-button',
  invoicePayConfirm: 'portal-invoice-pay-confirm-button',
  messageInput: 'portal-message-input',
  messageSend: 'portal-message-send-button',
  messagePhoto: 'portal-message-photo-input',
  newServiceRequest: 'portal-new-service-request-button',
  serviceRequestTitle: 'portal-sr-title-input',
  serviceRequestDescription: 'portal-sr-description-input',
  serviceRequestProperty: 'portal-sr-property-select',
  serviceRequestPhoto: 'portal-sr-photo-input',
  serviceRequestSubmit: 'portal-sr-submit-button',
  serviceRequestAccept: 'portal-sr-accept-button',
  serviceRequestDecline: 'portal-sr-decline-button',
  newReport: 'portal-new-report-button',
  reportTitle: 'portal-report-title-input',
  reportSubmit: 'portal-report-submit-button',
  googleCalUrl: 'portal-google-cal-url-input',
  googleCalSave: 'portal-google-cal-save-button',
  idleWarningStay: 'portal-idle-warning-stay-button',
};

export const ADMIN_PORTAL = {
  inviteButton: 'customer-invite-portal-button',
  serviceRequestQuoteAmount: 'admin-sr-quote-amount-input',
  serviceRequestQuoteSubmit: 'admin-sr-quote-submit-button',
  propertyGoogleCal: 'property-form-google-cal-input',
};
